<template>
  <div
    class="tw:flex tw:flex-col tw:gap-2 tw:w-full sm:tw:flex-1 tw:p-3 tw:border tw:border-default-200 tw:rounded-sm tw:transition-colors tw:duration-200 tw:ease-in-out"
    :class="isChecked && 'tw:bg-blue-000 tw:border tw:!border-blue-500'"
  >
    <EdroneToggle :checked="isChecked" :disabled="isDisabled" :controlled="true" @click="handleClick" />

    <p class="tw:body-2 tw:text-black">{{ label }}</p>

    <EdroneSkeletonLoader v-if="isLoading" class="tw:w-[7.5rem] tw:h-[2rem]" />
    <div v-else class="tw:flex tw:gap-1 tw:items-center">
      <p class="tw:heading-2 tw:text-black">{{ value || "-" }}</p>
      <EdroneBadge v-if="conversion" type="default" :label="conversion" size="small" />
    </div>

    <div class="tw:w-9 tw:border tw:border-b-[3px]" :class="borderClass" />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import EdroneSkeletonLoader from "edrone-components/EdroneSkeletonLoader.vue";
import EdroneToggle from "edrone-components/EdroneToggle.vue";
import EdroneBadge from "edrone-components/EdroneBadge/EdroneBadge.vue";

export type ProductReportAnalyticsChartMetricBoxType = "viewed" | "addedToCart" | "ordered";

export interface ProductReportAnalyticsChartMetricBoxProps {
  label: string;
  value: number | null;
  conversion?: number | null;
  type: ProductReportAnalyticsChartMetricBoxType;
  isChecked: boolean;
  isDisabled: boolean;
}

interface Props extends ProductReportAnalyticsChartMetricBoxProps {
  isLoading: boolean;
}

const props = defineProps<Props>();
const emit = defineEmits(["click"]);

const conversion = computed(() => {
  if (props.conversion) {
    return `${(props.conversion * 100).toFixed(2)}%`;
  }

  return null;
});

const borderClass = computed(() => {
  if (props.type === "viewed") {
    return "tw:border-default-900";
  }

  if (props.type === "addedToCart") {
    return "tw:border-blue-500";
  }

  if (props.type === "ordered") {
    return "tw:border-green-500";
  }

  return "tw:border-black";
});

const handleClick = (value: boolean) => {
  emit("click", { value, type: props.type });
};
</script>
